import React from 'react';
import { useSelector } from 'react-redux';
import { Table } from 'antd';

const MerchantWebsites = () => {
  const selectedMerchant = useSelector(({ data }) => data.selectedMerchantAccount);

  const tableProps = {
    pagination: false,
    columns: [
      {
        title: 'Websites',
        dataIndex: 'name',
      }],
    dataSource: selectedMerchant.websites ? selectedMerchant.websites.map((website) => ({ name: website })) : [],
  };
  return (
    <Table className="gx-table-responsive" {...tableProps} />
  );
};

export default MerchantWebsites;
